import React from "react";
import { Col, Container, Row, Table } from "reactstrap";
import { TableProveedores } from "./TableProveedores";

export function Proveedores() {
  const usuario = JSON.parse(sessionStorage.getItem("usuario"));
  const id_perfil = usuario?.id_perfil;

  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 style={{ marginBottom: 30, color: "#024b82" }}>
            {id_perfil === 9 ? "Crear proveedor" : "Registro de proveedor"}
          </h3>
        </Col>
      </Row>
      <Row>
        <TableProveedores />
      </Row>
    </Container>
  );
}
